import { useState, useEffect } from "react";
import { getRentersCount } from "../../../../common/services/renters.api";
import { getVehiclesCount } from "../../../../common/services/vehicles.api";
import { PARTNER_STATUS } from "../../../../types/partners.type";
import { usePartnerDashboardContext } from "../partner-dashboard/usePartnerDashboardContext";
import { Button } from "@/components/ui/button";
import { ModalViewLogs } from "@/modules/logsDetails/logsDetails.modal";

const STATUS_LABELS = {
  [PARTNER_STATUS.ACTIVE]: "Ativo",
  [PARTNER_STATUS.INACTIVE]: "Inativo",
  [PARTNER_STATUS.DEFAULTER]: "Inadimplente",
};

const STATUS_COLORS = {
  [PARTNER_STATUS.ACTIVE]: "font-semibold text-greenPrimary",
  [PARTNER_STATUS.INACTIVE]: "font-semibold text-gray",
  [PARTNER_STATUS.DEFAULTER]: "font-semibold text-redPrimary",
};

function getStatusLabels(status: PARTNER_STATUS) {
  return (
    <span
      className={`${STATUS_COLORS[status]}`}
      title={STATUS_LABELS[status] || status}
    >
      {STATUS_LABELS[status] || status}
    </span>
  );
}

export function ImageSelfPartnerBlock() {
  const { partner } = usePartnerDashboardContext();
  const [totalVehicles, setTotalVehicles] = useState(0);
  const [totalRenters, setTotalRenters] = useState(0);
  const [isLogModalOpen, setIsLogModalOpen] = useState(false);

  useEffect(() => {
    async function fetchTotalVehicles() {
      if (!partner?._id) return;
      const vehicles = await getVehiclesCount(partner._id);
      const renters = await getRentersCount(partner._id);

      if (vehicles.ok && renters.ok) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setTotalVehicles(vehicles.data as any);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setTotalRenters(renters.data as any);
      } else {
        console.error("Erro ao buscar veículos");
      }
    }
    if (partner) fetchTotalVehicles();
  }, [partner]);

  return (
    <>
      <div className="tabs-border-line">
        <section className="tabs-item-style">
          <div className="row-span-3 col-span-2 grid grid-rows-3 grid-cols-2">
            <h4 className="font-semibold text-2xl col-span-2">
              {" "}
              {partner.companyName}{" "}
            </h4>
            <span className="p-2 flex items-center bg-white/30 rounded-l-md border border-gray/50 border-r-0">
              {" "}
              Titular da empresa:{" "}
            </span>
            <span className="p-2 flex items-center justify-end bg-white/30 rounded-r-md border border-gray/50 border-l-0">
              {" "}
              {partner.owner.name}{" "}
            </span>
            <span className="p-2 flex items-center bg-white/30 rounded-l-md border border-gray/50 border-r-0">
              {" "}
              Telefone:{" "}
            </span>
            <span className="p-2 flex items-center justify-end bg-white/30 rounded-r-md border border-gray/50 border-l-0">
              {" "}
              {partner.owner.phone}{" "}
            </span>
            <span className="p-2 flex items-center bg-white/50 rounded-l-md border border-gray/50 border-r-0">
              {" "}
              Status:{" "}
            </span>
            <span className="p-2 flex items-center justify-end bg-white/50 rounded-r-md border border-gray/50 border-l-0">
              {getStatusLabels(partner.status as PARTNER_STATUS)}
            </span>
          </div>
        </section>

        <div className="div-tabs-border-line"></div>

        <section className="tabs-item-style">
          <div className="row-span-3 col-span-2 grid grid-rows-1 grid-cols-2">
            <span className="p-2 flex items-center bg-white/50 rounded-l-md border border-gray/50 border-r-0">
              {" "}
              Total de Motos:{" "}
            </span>
            <span className="p-2 flex items- justify-end bg-white/50 rounded-r-md border border-gray/50 border-l-0">
              {totalVehicles === null
                ? ""
                : totalVehicles === 0
                ? "0"
                : totalVehicles}
            </span>{" "}
          </div>
          <div className="row-span-2 col-span-2 grid grid-rows-1 grid-cols-2">
            <span className="p-2 flex items-center  bg-white/50 rounded-l-md border border-gray/50 border-r-0">
              {" "}
              Total de Clientes:{" "}
            </span>
            <span className="p-2 flex items- justify-end bg-white/50 rounded-r-md border border-gray/50 border-l-0">
              {totalRenters === null
                ? ""
                : totalRenters === 0
                ? "0"
                : totalRenters}
            </span>
          </div>
        </section>
        <div className="div-tabs-border-line"></div>
        <section className="tabs-item-style">
          <div className="max-w-7xl mx-auto ">
            <Button
              variant="destructive"
              className={`bg-redPrimary text-white font-semibold p-2 rounded-md mb-2 sm:mb-0`}
              onClick={() => setIsLogModalOpen(true)}
            >
              Visualizar Logs
            </Button>
          </div>
        </section>
      </div>
      {isLogModalOpen && partner._id && (
        <ModalViewLogs
          onClose={() => setIsLogModalOpen(false)}
          entity="partner" // Entidade fixa como solicitado
          entityId={partner._id} // ID do veículo do contexto
        />
      )}
    </>
  );
}
